import { render, staticRenderFns } from "./todoFormList.vue?vue&type=template&id=74f27667&"
import script from "./todoFormList.vue?vue&type=script&lang=ts&"
export * from "./todoFormList.vue?vue&type=script&lang=ts&"
import style0 from "./todoFormList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports